import {defaultLineChartOptions} from './options-chart-line';
import {optionsColumnChart} from './options-chart-column';
import {formatDateTimeWithPatternAndTimeOffset, adjustHAsixTicks} from '../../utils/chartsTimeZoneUtils'

/*
* Chart in single sensor detail view.
* */
export const drawSensorChart = (dataChart, containerId, chartType, curSensorLabel, chartOptions, timeZoneOffset) => {
    google.charts.load('current', {'packages': ['corechart']});
    google.charts.setOnLoadCallback(drawChart);

    // RWD.
    google.charts.load('current', {
        callback: function () {
            drawChart();
            window.addEventListener('resize', (e) => {
                drawChart();
            });
        },
        packages: ['corechart']
    });

    function drawChart() {
        let dataTable = new google.visualization.DataTable();

        dataTable.addColumn('datetime', 'Date');
        dataTable.addColumn('number', 'Value');
        dataTable.addColumn('number', 'Orange Level');
        dataTable.addColumn('number', 'Red Level');

        if ('LineChart' === chartType) {
            dataTable.addColumn({
                role: 'style',
                type: 'string'
            });
        }

        dataTable.addRows(dataChart);


        // Drawing chart based on chart type from setChartType().
        let chart;
        if (chartType === 'LineChart') {
            chart = new google.visualization.LineChart(document.getElementById(containerId));
            let finalOptions = {...defaultLineChartOptions, ...chartOptions};

            formatDateTimeWithPatternAndTimeOffset(dataTable, finalOptions, timeZoneOffset);
            adjustHAsixTicks(dataTable, finalOptions);
            chart.draw(dataTable, finalOptions);

            document.querySelector('.c-box__header-label--1').innerHTML = curSensorLabel;

        } else if (chartType === 'ColumnChart') {
            chart = new google.visualization.ColumnChart(document.getElementById(containerId));
            chart.draw(dataTable, optionsColumnChart);
            document.querySelector('.c-box__header-label--2').innerHTML = curSensorLabel;
        }

    }
};
